import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const roundToTwoDecimals = (value) => {
    return Math.round(value * 100) / 100;
};
export function AverageNcDaysIndustryCard({ options }) {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [fleetAverage, setFleetAverage] = useState(null);
    const [industryAverage, setIndustryAverage] = useState(null);
    useEffect(() => {
        if (!options.isReady) {
            setIsLoading(false);
            setErrorMessage("");
            setFleetAverage(null);
            setIndustryAverage(null);
            return;
        }
        setIsLoading(true);
        setErrorMessage("");
        setFleetAverage(null);
        setIndustryAverage(null);
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/quarterly/globalstat?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            if (data === null) {
                setFleetAverage(null);
                setIndustryAverage(null);
                return;
            }
            setFleetAverage(data.UserAverage === null ? null : roundToTwoDecimals(data.UserAverage));
            setIndustryAverage(data.IndustryAverage === null ? null : roundToTwoDecimals(data.IndustryAverage));
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching industry comparison data");
        })
            .finally(() => setIsLoading(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const comparisonClass = fleetAverage === null || industryAverage === null
        ? "text-muted"
        : fleetAverage < industryAverage
            ? "text-success"
            : fleetAverage > industryAverage
                ? "text-danger"
                : "text-muted";
    const comparisonLabel = fleetAverage === null || industryAverage === null
        ? ""
        : fleetAverage < industryAverage
            ? "Below industry average"
            : fleetAverage > industryAverage
                ? "Above industry average"
                : "Equal to industry average";
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Avg NC Days / Vessel / Month" }), _jsxs("div", { className: "card-body d-flex flex-column", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), _jsxs("div", { className: "mt-auto", children: [fleetAverage !== null && !isLoading && options.isReady && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "d-flex align-items-baseline gap-2 mb-1", children: [_jsx("h1", { className: "mb-0", children: fleetAverage }), _jsxs("span", { className: "text-muted", children: ["(vs ", industryAverage, " industry avg)"] })] }), _jsx("p", { className: `mb-0 ${comparisonClass}`, children: comparisonLabel })] })), options.isReady && !isLoading && fleetAverage === null && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." }))] })] })] }));
}
